import { HttpMethods, sendRequest, LoginType, getPreBootstrapConfig } from "../util/ApiHelper";

export interface ActionAuditDTO {
    SelectedPlant?: string;
    SelectedDatabase?: string;
    InvocationUrl?: string;
    ApplicationType?: string;
    DisplayName?: string;
};

export const actionUpdateAuditLog = async (data: ActionAuditDTO) => {
    const preBootstrapConfig = await getPreBootstrapConfig();
    return await sendRequest(
        HttpMethods.GET,
        `${preBootstrapConfig.MOBILE_BOOTSTRAP_API_BASE_ADDRESS}AppLaunch/GetApplicationLaunchDetails`,
        undefined,
        {
            SelectedPlant: data.SelectedPlant || '',
            SelectedDatabase: data.SelectedDatabase || '',
            InvocationUrl: data.InvocationUrl || '',
            ApplicationType: data.ApplicationType || '',
            DisplayName: data.DisplayName || ''
        },
        false,
        LoginType.Portal,
        true
    );
};

